import { render, staticRenderFns } from "./CommissionAuthorization.vue?vue&type=template&id=4efe8c28&scoped=true"
import script from "./CommissionAuthorization.vue?vue&type=script&lang=js"
export * from "./CommissionAuthorization.vue?vue&type=script&lang=js"
import style0 from "./CommissionAuthorization.vue?vue&type=style&index=0&id=4efe8c28&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efe8c28",
  null
  
)

export default component.exports